import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { selectors as authSelectors } from 'store/auth';
import { useSelector } from 'react-redux';
import ClientSelectView from 'views/ClientSelectView';
import DashboardRoutes from './DashboardRoutes';

const ProtectedRoutes: React.FC = () => {
  // SELECTORS
  const isAuthenticated = useSelector(authSelectors.selectIsAuthenticated);
  const authenticating = useSelector(authSelectors.selectAuthenticating);
  const admin = useSelector(authSelectors.selectAdmin);

  // IF NOT AUTHENTICATING AND IS NOT AUTHENTICATED - REROUTE TO SIGNIN (SignInView)
  if (admin && admin.resetPasswordRequired) return <Redirect to="/resetpassword" />;
  if (!authenticating && !isAuthenticated) return <Redirect to="/" />;

  return (
    <Switch>
      <Route exact path="/clients" component={ClientSelectView} />
      <DashboardRoutes />
    </Switch>
  );
};

export default ProtectedRoutes;
